/*
 * Images rotation jQuery plugin | 2014-08-12
 * Copyright (c) 2013-2014 sladex | MIT License
 * https://github.com/sladex/images-rotation
 */
import $ from "cash-dom";

$.fn.imagesRotation = function (options) {
    let defaults = {
            images: [],         // urls to images
            dataAttr: 'images', // html5 data- attribute which contains an array with urls to images
            imgSelector: 'img', // element to change
            interval: 1000,     // ms
            intervalFirst: 500, // first image change, ms
            callback: null      // first argument would be the current image url
        },
        settings = $.extend({}, defaults, options);

    let clearRotationInterval = function ($el) {
            clearInterval($el.data('imagesRotaionTimeout'));
            $el.removeData('imagesRotaionTimeout');
            clearInterval($el.data('imagesRotaionInterval'));
            $el.removeData('imagesRotaionInterval');
        },
        getImagesArray = function ($this) {
            let images = settings.images.length ? settings.images : $this.data(settings.dataAttr);
            return $.isArray(images) ? images : false;
        },
        preload = function (arr) {  // images preloader
            $(arr).each(function () {
                $('<img/>')[0].src = this;
            });
        }

    this.on('mouseenter.imagesRotation', function () {
        let $this = $(this),
            $img = settings.imgSelector ? $(settings.imgSelector, $this) : null,
            baseurl = $this.data('image-baseurl'),
            images = [];
            $.each(getImagesArray($this), function(key, value) {
                images.push(baseurl.replace("#BASEURL#", value));
            });
            let imagesLength = images ? images.length : null,
            changeImg = function () {
                let prevIndex = $this.data('imagesRotationIndex') || 0,
                    index = (prevIndex + 1 < imagesLength) ? prevIndex + 1 : 0,
                    nextIndex = (index + 1 < imagesLength) ? index + 1 : 0;
                $this.data('imagesRotationIndex', index);
                if ($img && $img.length > 0) {
                    if ($img.is('img')) {
                        let $parent = $img.parent();
                        if(prevIndex === 0){
                            let img = new Image();
                            img.classList.add('hidden');
                            img.alt = $img.attr('title');
                            img.onload = function(){
                                let thisImage = this;
                                $parent.append(thisImage);
                                replaceImage(thisImage);
                            }
                            img.src = images[index];
                        } else {
                            let $newImg = $('<img>').attr({'class' : 'hidden', 'alt' : $img.attr('title'), 'src' : images[index] });
                            $parent.append($newImg);
                            replaceImage($newImg.get(0));
                        }
                    }
                    else {
                        $img.css('background-image', 'url(' + images[index] + ')');
                    }
                }
                if (settings.callback) {
                    settings.callback(images[index]);
                }
                preload([images[nextIndex]]); // preload next image
            }

        let replaceImage = function (imageObj) {
            window.setTimeout(function () {
                $(imageObj).removeClass('hidden');
                $img.addClass('hidden');
                window.setTimeout(function () {
                    $img.remove();
                    $img = $(imageObj);
                }, settings.intervalFirst);
            }, settings.intervalFirst);
        };

        if (imagesLength) {
            clearRotationInterval($this); // in case of dummy intervals
            let timeout = setTimeout(function () {
                changeImg();
                let interval = setInterval(changeImg, settings.interval);
                $this.data('imagesRotaionInterval', interval); // store to clear interval on mouseleave
            }, settings.intervalFirst);
            $this.data('imagesRotaionTimeout', timeout);
        }
    }).on('mouseleave.imagesRotation', function () {
        clearRotationInterval($(this));
    }).on('imagesRotationRemove', function () {
        let $that = $(this);
        $that.off('.imagesRotation');
        clearRotationInterval($that);
    });
};

$.fn.imagesRotationRemove = function () {
    this.trigger('imagesRotationRemove');
};